import { render, staticRenderFns } from "./userInfoEdit.vue?vue&type=template&id=b98f1f1c"
import script from "./userInfoEdit.vue?vue&type=script&lang=js"
export * from "./userInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./userInfoEdit.vue?vue&type=style&index=0&id=b98f1f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports